module.exports = {
    abrirModulo: 'Abrir exame no módulo de',
    adicionarAnexo: 'Adicionar anexo',
    adicionarSecao: 'Adicionar seção',
    agendado: 'Agendado',
    agendados: 'Agendados',
    agendamentoExame: 'Agendamento de exame',
    alertaLaudoAcessado_adm: 'Atenção, os seguintes laudos já foram acessados: %s. Ao realizar a alteração, eles perderão assinatura digital e precisarão ser assinados novamente pelo médico responsável pelo laudo%s. Deseja continuar?',
    alertaLaudoAcessado_executor: 'Atenção, os seguintes exames já foram acessados: %s. Ao realizar a alteração eles perderão assinatura digital e precisarão ser assinados novamente%s. Deseja continuar?',
    alertaLaudoAssinado: 'Atenção, os seguintes exames possuem laudos recentes assinados digitalmente: %s. Ao realizar a alteração, eles perderão a assinatura digital e precisarão ser assinados novamente pelo médico responsável pelo laudo%s. Deseja continuar?',
    alteracaoLaudoAtalho: 'Alterar o Atalho',
    alteracaoModeloLaudo: 'Alteração de modelo de laudo',
    anexoInserido: 'Anexo registrado',
    assinado: 'Assinado',
    assinando: 'Assinando',
    assinarDepois: 'Assinar depois',
    assinarEsteEProximosLaudos: 'Assinar este e os próximos laudos',
    assinarEsteLaudoApenas: 'Assinar este laudo apenas',
    assinaturaDigital: 'Assinatura digital',
    assinaturaNecessaria: 'A assinatuda digital dos laudo é obrigatória. O que deseja fazer?',
    assuntoNotificacaoLaudoAlterado: 'Laudo alterado para o exame de %1',
    assuntoNotificacaoPacienteAlterado: '[Ação necessária] - Atualização dos dados cadastrais de %1',
    atalho: 'Atalho',
    atalhoAtivar: 'Ativar',
    atalhoAtivo: 'Ativo',
    atalhoAtivoDesativoComSucesso: 'Atalho "$" ! com sucesso.',
    atalhoInativar: 'Inativar',
    atalhoInativo: 'Inativo',
    atalhoLaudo: 'Atalhos de Laudo',
    baixandoExame: 'Baixando exame',
    baixarWeasis: 'Para instalar o Weasis, siga as instruções disponíveis neste link: <a href="https://weasis.org/en/getting-started/index.html" target="_blank" rel="noopener noreferrer">Baixar Weasis</a>.',
    cadastroIncompleto: 'Cadastro incompleto',
    cadastroLaudoAtalho: 'Atalhos para laudo',
    cadastroModeloLaudo: 'Cadastro de modelo de laudo',
    campoNaoPodeSerVazio: 'O Campo não deve começar com espaço',
    carregandoExame: 'Carregando o exame',
    carregandoHistoricoExames: 'Carregando histórico do exame',
    carregarExamesAutomaticamente: 'Carregar exames automaticamente',
    carregarProximoExameAutomaticamente: 'Carregar próximo exame automaticamente',
    categoria: 'Categoria',
    comImagem: 'Com imagem',
    comLaudo: 'Com laudo',
    complementoLaudo: 'Complemento de laudo',
    completarDadosPaciente: 'Completar cadastro',
    confirmacaoAtivarDesativarAtalho: 'Deseja realmente ! o Atalho: "$".',
    confirmacaoVinculoDados: 'Você confirma o vínculo dessas informações ao exame atual?',
    confirmaEncaminhamentoLaudo: 'Confirma o encaminhamento deste laudo para "$"?',
    confirmaRemocaoAnexo: 'Você confirma a remoção do anexo?',
    confirmaRemocaoModeloLaudo: 'Você confirma a remoção do modelo de laudo?',
    confirmaRemocaoSecaoModeloLaudo: 'Você confirma a remoção da seção?',
    confirmarEnviarPacienteExameAgendado: 'Você confirma o envio dos dados corrigidos do paciente?',
    confirmarEscolhaNecessidadeInformarCpfPaciente: 'Você confirma esta escolha? O sistema irá vincular o exame a este paciente e prosseguir.',
    confirmarEscolhaSolicitanteVinculoExame: 'Você confirma esta escolha? O sistema irá vincular o exame a este médico solicitante e prosseguir.',
    confirmarGestaoExame: 'Você confirma o ajuste deste exame?',
    conteudoNotificacaoLaudoAlterado: 'Foi publicada uma nova versão do laudo do exame de %1 (protocolo: %2). Por favor, acesse o sistema para verificar se houve alterações.',
    conteudoNotificacaoPacienteAlterado: 'Os dados cadastrais do/a paciente %1 foram atualizados, podendo ter causado divergências em relação aos dados contidos no laudo do exame %2. Por favor, verifique as informações e republique o laudo.',
    contraRefercia: 'Contra-referência',
    copiandoLaudo: 'Copiando laudo',
    copiarLaudo: 'Copiar laudo',
    correcaoDadosPaciente: 'Correção de dados do paciente',
    correcaoDadosPacienteWorklist: 'Correção de dados do paciente na Worklist',
    corrigirDadosPaciente: 'Corrigir cadastro',
    corrigirPaciente: 'Corrigir paciente',
    dataAcao: 'Data da Ação',
    dataHoraAtendimento: 'Data/hora do atendimento',
    dataLaudo: 'Data do laudo',
    dataUltimaAcao: 'Data da última ação',
    deletarFiltros: 'Deletar Filtros',
    descricaoDoAtalho: 'Descrição do atalho',
    descricaoExame: 'Descrição do exame',
    descricaoJaAdicionada: 'Descrição já adicionada',
    descricaoNecessidadeInformarCpfPaciente: 'Este paciente não possui CPF cadastrado no sistema. Por favor, informe o CPF ou cartão SUS, clique em "Buscar" e selecione um paciente da listagem para continuar com a impressão do protocolo',
    descricaoNecessidadeInformarDataNascimentoPaciente: 'Este paciente não possui data de nascimento cadastrada no sistema. Por favor, informe a data de nascimento e clique em Salvar para finalizar o complemento deste cadastro.',
    descricaoNecessidadeInformarMedicoSolicitante: 'Este exame não possui um médico solicitante vinculado. Por favor, informe o médico solicitante e clique em Salvar para finalizar o complemento dos dados.',
    descricaoProcedimento: 'Descrição do procedimento',
    desejaAdicionarOuSubstituir: 'Adicionar ao modelo atual ou substituir o modelo atual?',
    desejaDeletarFiltros: 'Deseja excluir esta aba de filtros?',
    destacarOhif: 'Destacar OHIF',
    devolverListaGeral: 'Devolver para lista geral',
    direcionado: 'Direcionado',
    direcionados: 'Direcionado',
    direcionadosAMim: 'Direcionados a mim',
    encaminhamentoRevisao: 'Encaminhamento do laudo para revisão',
    erroAlterarAtalhoAtivo: 'Erro ao alternar ativo do atalho. Por favor, tente novamente.',
    erroCarregarAtalhos: 'Não foi possível carregar os atalhos.',
    erroCarregarExame: 'Não foi possível carregar o exame',
    erroCarregarFabricaLaudo: 'Não foi possível carregar a fábrica de laudos',
    erroCarregarListaExames: 'Não foi possível carregar a lista de exames. Por favor, tente novamente.',
    erroCarregarMedicosExecutores: 'Não foi possível carregar os médicos executores. Não será possível encaminhar o laudo para complemento.',
    erroCarregarModelosInstituicao: 'Não foi possível carregar os modelos de laudo da instituição.',
    erroCarregarModelosUsuario: 'Não foi possível carregar os modelos de laudo do usuário.',
    erroCarregarParametrosAssinaturaDigital: 'Não foi possível carregar os parâmetros de configuração da assinatura digital.',
    erroDeletarFiltros: 'Não foi possível deletar os filtros.',
    erroDownloadWeasis: 'Download do Weasis indisponível. Tente novamente mais tarde.',
    erroRequisicao: 'A requisição deve conter apenas caracteres alfanuméricos',
    exameAtual: 'Exame atual',
    exameDevolvidoListaGeral: 'Exame devolvido para lista geral',
    examesAgendados: 'Agendados',
    examesComImagens: 'Com imagens',
    examesDoDia: 'Exames do dia',
    exameSelecionado: 'Exame selecionado',
    exameSemPermissaoGaleria: 'A visualização de imagens deste exame não é permitida.',
    examesInvalidos: 'Inválidos',
    examesPacs: 'PACS',
    examesSelecionados: 'Exames selecionados',
    examesValidos: 'Válidos',
    exameValidado: 'Exame validado',
    fecharOhif: 'Fechar OHIF',
    filtroDataRemovido: 'Os filtros por data do exame serão removidos.',
    filtrosSalvos: 'Filtros salvos com sucesso',
    formularioSolicitacaoMed: 'Formulário de solicitação de medicamentos',
    gerirExame: 'Gerir exame',
    helperOhifAtualizacao: 'Helper STT OHIF - Atualização',
    helperOhifNaoInstalado: 'Helper STT Ohif não instalado',
    helperOhifNaoInstalado: 'Helper STT OHIF não instalado',
    identificacaoPaciente: 'Identificação do paciente',
    identificador: 'Identificador',
    indicacao: 'Indicação',
    indicacaoClinicaRegistrada: 'Indicação clínica registrada',
    informarOutroMomento: 'Informar em outro momento',
    informarOutroMomento: 'Informar em outro momento',
    inicio: 'Início',
    integracaoExames: 'Integrações de Exames',
    invalido: 'Inválido',
    justificarAlteracaoLaudo: 'Justificar alteração de laudo',
    laudadoPorMim: 'Laudados por mim',
    laudoAguardandoAssinatura: 'Laudo aguardando assinatura',
    laudoAssinado: 'Laudo assinado',
    laudoRegistrado: 'Laudo registrado',
    laudos: 'Laudos',
    laudosAssinados: 'laudos assinados',
    laudosGraves: 'Laudos graves',
    laudoTemporario: 'Laudo temporário',
    linhaDeProducaoJaCadastrada: 'Já existe um conjunto de filtros cadastrado com este nome. Deseja substituí-lo?',
    medicoExecutor: 'Médico executor',
    mensagem: 'Mensagem',
    mensagemAlteracaoAtalho: 'Deseja alterar o Atalho: "$".',
    mensagemHelperAtualizacao: 'Existe uma atualização disponível do Helper STT OHIF, deseja fazer download?',
    mensagemHelperDownload: 'Se você usa mais de um monitor, o Helper STT Ohif ajuda a identificar as telas e abre a janela do Ohif no monitor secundário, sem sobrepor a janela com o módulo de exames. Deseja fazer download?',
    mensagemHelperDownload: 'O Helper STT OHIF não está instalado, deseja fazer download?',
    mensagemSemNatsInstituicao: `<p>Não é possível fazer uma solicitação para a Worklist pois não há instituições habilitadas para esse profissional.</p>`,
    modeloLaudo: 'Modelos de laudo',
    modelosLaudoInstituicao: 'Modelo de laudo da instituição',
    modelosLaudoUsuario: 'Modelo de laudo do usuário',
    naoPerguntarNovamente: 'Não perguntar novamente',
    NaoPerguntarNovamente: 'Não perguntar novamente',
    naoPossuoCpfPaciente: 'Não possuo os dados desse paciente',
    necessidadeInformarCpfPaciente: 'Informe o CPF do paciente',
    necessidadeInformarDataNascimentoPaciente: 'Informe a data de nascimento do paciente',
    nomeDoAtalho: 'Nome',
    novaRede: 'Nova rede',
    numero_exame: 'Número do exame',
    numeroExame: 'Número do Exame',
    numeroLaudo: 'Número do laudo',
    ohif: 'OHIF',
    opcoes: 'Opções',
    oQueDesejaFazer: 'O que deseja fazer?',
    outrasInformacoes: 'Outras informações',
    oviyam: 'Oviyam',
    pacienteNaoEncontradoInformarCpfCns: 'Nenhum paciente foi encontrado com este CPF ou CNS no sistema ou na base de dados do CADSUS. Você deseja vincular estes dados mesmo assim?',
    pacs: 'PACS',
    pdfIndisponivel: 'A geração do PDF deste exame apresentou erros e não está disponível. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    pesquisar: 'Pesquisar',
    pesquisaSimples: 'Pesquisa simples',
    placeholderSepareTermos: 'Separe os termos com espaço',
    preparandoEditorTexto: 'Preparando o editor de texto',
    preparandoEstudo: 'Preparando estudo',
    priorizado: 'Priorizado',
    profissional: 'Profissional',
    protocoloMed: 'Protocolo de medicamento',
    proximoExame: 'Próximo exame',
    qualquerExecutor: 'Qualquer médico executor da instituição',
    qualquerTermo: 'Qualquer um dos termos',
    realizacaoExame: 'Realização do exame',
    receitaMedica: 'Receita médica',
    redeAlterada: 'Rede alterada',
    removerSecao: 'Remover seção',
    responsavelEnvio: 'Responsável pelo envio',
    resumo: 'Visualizar resumo',
    resumoLaudo: 'Resumo do laudo',
    rotina: 'Rotina',
    salvarFiltros: 'Salvar filtros',
    secoesModelo: 'Seções do modelo',
    selecionado: 'selecionado',
    semImagensExibicao: 'Não há imagens disponíveis para exibição.',
    situacaoOrigem: 'Situação/Origem',
    somenteImagens: 'Somente exames com imagens',
    status: 'Status',
    substituir: 'Substituir',
    sucessoDeletarFiltros: 'Filtros removidos com sucesso',
    sucessoGestaoExame: 'Gestão dos dados do exame realizada com sucesso',
    sucessoNecessidadeInformarCpfPaciente: 'O paciente foi vinculado com sucesso',
    sucessoVinculoSolicitante: 'Médico solicitante vinculado com sucesso',
    telediagnostico: 'Telediagnóstico',
    termosDescricao: 'Descrição do exame',
    textoAjudaAssinarDepois: 'Este e os próximos laudos serão adicionados às pendências e deverão ser assinados posteriormente.',
    textoAjudaAssinarEsteApenas: 'Apenas este laudo será assinado.',
    textoAjudaSessaoAssinatura: 'Será iniciada uma sessão de assinatura e os laudos serão assinados automaticamente a medida que forem emitidos.',
    textoSecao: 'Texto da seção',
    tipoBusca: 'Tipo de busca por termo',
    tituloSecao: 'Título da seção',
    tituloVisualizacao: 'Visualização de Histórico',
    todosTermos: 'Todos os termos',
    trocarRede: 'Trocar rede',
    ultrapassouTempoPrevisto: 'Ultrapassou o tempo previsto para laudo',
    urlPacs: 'URL do PACS',
    usarVisualizadorPadrao: 'Usar visualizador de imagens padrão',
    validado: 'Validado',
    valido: 'Válido',
    vincularMedicoSolicitante: 'Vincular médico solicitante',
    visualizacaoPreviaModeloLaudo: 'Visualização prévia do modelo',
    weasis: 'WEASIS',
    worklist: 'Worklist'
};
